module.exports = require("injection-js");